import { render, staticRenderFns } from "./commissionDeclareZX.vue?vue&type=template&id=6af25a05"
import script from "./commissionDeclareZX.vue?vue&type=script&lang=js"
export * from "./commissionDeclareZX.vue?vue&type=script&lang=js"
import style0 from "./commissionDeclareZX.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports